export enum AppFeatureSwitch {
  Payroll = 46
}

export enum AppPermission {
  MeetingNotesView = 10001,
  MeetingNotesEdit = 10002,
  MeetingNotesMaster = 3212,
  PayrollApprovalApprove = 154,
  PayrollApprovalViewAll = 3022,
  PayrollApprovalShowAllItems = 3069,
  PayrollApprovalViewAssigned = 3120,
  PayrollApprovalEditItems = 3126,
  PayrollApprovalViewMainCampus = 6030,
  HRPortalReimbursementsHRApproval = 12008,
  HRPortalReimbursementsAAInitialApproval = 12009,
  HRPortalReimbursementTypesView = 12010,
  HRPortalReimbursementTypesEdit = 12011,
  LittleTiffUse = 12001
}
